var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"loader light"},[_c('div',[_c('div',[_c('img',{attrs:{"src":"/images/loading_green.gif"}})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }